export default function () {
  return [
    // Dashboard
    {
      title: 'Painel de controle',
      name: 'dashboard',
      to: {
        name: 'admin-overview',
      },
      htmlBefore: '<i class="material-icons">dashboard</i>',
    },
    // Products
    {
      title: 'Produtos',
      name: 'products',
      htmlBefore: '<i class="material-icons">local_mall</i>',
      to: {
        name: 'admin-product-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-product-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-product-new',
          },
        },
      ],
    },
    // Lead
    {
      title: 'Indicações',
      name: 'leads',
      isRepresentative: false,
      to: {
        name: 'admin-lead-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">location_on</i>',
    },
    // Reseller
    {
      title: 'Lojas Parceiras',
      name: 'resellers',
      isReseller: false,
      isRepresentative: true,
      to: {
        name: 'admin-reseller-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">contacts</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-reseller-list',
            params: {
              page: 1,
            },
          },
        },
        {
          isRepresentative: false,
          title: 'Adicionar',
          to: {
            name: 'admin-reseller-new',
          },
        },
      ],
    },
    // Reseller Perfil
    // {
    //   title: 'Perfil da Loja',
    //   name: 'resellers',
    //   isReseller: true,
    //   isCommercial: false,
    //   isAdmin: false,
    //   to: {
    //     name: 'admin-reseller-perfil',
    //   },
    //   htmlBefore: '<i class="material-icons">contacts</i>',
    // },
    // CommercialTeam
    {
      title: 'Equipe comercial',
      name: 'commercial_teams',
      isCommercial: false,
      htmlBefore: '<i class="material-icons">group</i>',
      to: {
        name: 'admin-commercial-team-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-commercial-team-list',
            params: {
              page: 1,
            },
          },
        },
      ],
    },
    // Comemrcial Perfil
    {
      title: 'Perfil Comercial',
      name: 'commercial_teams',
      isCommercial: true,
      isAdmin: false,
      to: {
        name: 'admin-commercial-team-perfil',
      },
      htmlBefore: '<i class="material-icons">record_voice_over</i>',
    },
    // Representative
    {
      title: 'Representante',
      name: 'representatives',
      isCommercial: true,
      htmlBefore: '<i class="material-icons">record_voice_over</i>',
      to: {
        name: 'admin-representative-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-representative-list',
            params: {
              page: 1,
            },
          },
        },
      ],
    },
    // Feed
    {
      title: 'Feed',
      name: 'feeds',
      to: {
        name: 'admin-feed-list',
      },
      htmlBefore: '<i class="material-icons">ballot</i>',
    },
    // User
    {
      title: 'Usuários',
      name: 'users',
      to: {
        name: 'admin-user-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">perm_identity</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-user-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-user-new',
          },
        },
      ],
    },
    // Reports
    {
      title: 'Relatórios',
      name: 'reports',
      isTester: false,
      htmlBefore: '<i class="material-icons">report</i>',
      to: {
        name: 'admin-report-product',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Produtos',
          to: {
            name: 'admin-report-product',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Usuários',
          to: {
            name: 'admin-report-user',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Tags',
          to: {
            name: 'admin-report-tags',
            params: {
              page: 1,
            },
          },
        },
      ],
    },
    {
      title: 'Relatórios',
      name: 'reports',
      isTester: true,
      isAdmin: false,
      to: {
        name: 'admin-report-tags',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">report</i>',
    },
  ];
}
